import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dimensions-normalized',
  templateUrl: './dimensions-normalized.component.html',
  styleUrls: ['./dimensions-normalized.component.scss']
})
export class DimensionsNormalizedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {}

}
